// Vendor
import { createAction, props } from '@ngrx/store';
export const addFundChartCorrelation = createAction('[Fund Chart] Add Correlation', props());
export const toggleFundChartCorrelation = createAction('[Fund Chart] Toggle Correlation', props());
export const updateFundChartCorrelation = createAction('[Fund Chart] Update Correlation', props());
export const removeFundChartCorrelation = createAction('[Fund Chart] Remove Correlation', props());
export const setFundChartCorrelations = createAction('[Fund Chart] Set Correlations', props());
